import { PageDetailsFragment } from "@dashboard/graphql";

const DEFAULT_REVALIDATE_PATH = "/api/page-update";

const getStorefrontBaseUrl = () =>
  process.env.NEXT_PUBLIC_STOREFRONT_BASE_URL?.trim().replace(/\/+$/, "");

const getRevalidateSecret = () => process.env.STOREFRONT_REVALIDATE_SECRET?.trim();

const getPageSlug = (page?: Pick<PageDetailsFragment, "slug"> | null) =>
  page?.slug?.trim().replace(/^\/+/, "") || null;

export interface RevalidateModelsInput {
  page?: Pick<PageDetailsFragment, "id" | "slug"> | null;
  pages?: Array<Pick<PageDetailsFragment, "id" | "slug"> | null | undefined>;
}

export const revalidateModelsInStorefront = async ({
  page,
  pages = [],
}: RevalidateModelsInput = {}) => {
  const storefrontBaseUrl = getStorefrontBaseUrl();

  if (!storefrontBaseUrl) {
    return;
  }

  const allPages = [page, ...pages].filter(Boolean);
  const slugs = [...new Set(allPages.map(getPageSlug).filter(Boolean))];

  if (slugs.length === 0) {
    return;
  }

  try {
    const response = await fetch(`${storefrontBaseUrl}${DEFAULT_REVALIDATE_PATH}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        ...(getRevalidateSecret() ? { "x-revalidate-secret": getRevalidateSecret() } : {}),
      },
      body: JSON.stringify({
        slugs,
      }),
    });

    if (!response.ok) {
      console.warn(`Storefront model revalidation failed with status ${response.status}`);
    }
  } catch (error) {
    console.warn("Storefront model revalidation failed", error);
  }
};
